export default {
  mounted() {
    // Find the main scrollable container
    this.scrollContainer = document.getElementById('layout-v2-main-body')

    if (!this.scrollContainer) {
      console.error('ScrollManager: Could not find element with id "layout-v2-main-body"')
      return
    }

    this.debounceTimer = null

    // Restore scroll position on mount
    const shouldRestore = this.el.dataset.shouldRestoreScroll === "true"
    const scrollPosition = parseInt(this.el.dataset.scrollPosition || "0")

    // Listen for restore_scroll event from LiveView
    this.handleEvent("restore_scroll", ({position}) => {
      const scrollPos = parseInt(position)
      if (scrollPos > 0) {
        // Small delay to ensure DOM is fully rendered
        setTimeout(() => {
          this.scrollContainer.scrollTop = scrollPos
        }, 50)
      }
    })

    // Listen for update_loaded_count event from LiveView
    this.handleEvent("update_loaded_count", ({count}) => {
      const url = new URL(window.location)
      url.searchParams.set('loaded', count.toString())

      console.log('Updating URL with loaded count:', count)
      // Update URL without triggering LiveView's handle_params
      window.history.replaceState(null, '', url.toString())
    })

    // Listen for scroll_by event from LiveView
    this.handleEvent("scroll_by", ({x, y}) => {
      if (this.scrollContainer) {
        this.scrollContainer.scrollBy(x, y)
      }
    })

    // Listen for scroll events on the main container (debounced)
    this.scrollEventHandler = (e) => {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.updateURLWithoutReload(e.target.scrollTop)
      }, 300) // 300ms debounce
    }

    this.scrollContainer.addEventListener('scroll', this.scrollEventHandler)
  },

  updateURLWithoutReload(scrollPosition) {
    const url = new URL(window.location)
    url.searchParams.set('scroll', Math.floor(scrollPosition).toString())

    // Update URL without triggering LiveView's handle_params
    window.history.replaceState(null, '', url.toString())
  },

  destroyed() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    // Clean up event listener
    if (this.scrollContainer && this.scrollEventHandler) {
      this.scrollContainer.removeEventListener('scroll', this.scrollEventHandler)
    }
  }
}
